import * as Types from '../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ChargesQueryVariables = Types.Exact<{
  projectCharges: Array<Types.Scalars['Int']> | Types.Scalars['Int'];
}>;


export type ChargesQuery = { __typename?: 'QueryModel', projectCharges?: { __typename?: 'ProjectChargesQueryModel', charges?: Array<{ __typename?: 'ProjectCharge', id: number, label: string, notes?: string | null, date: string, rate: number, unit?: Types.RateUnit | null, quantity?: number | null, timesheetQuantity?: number | null, eeCode: string, total?: number | null, state: Types.ProjectChargeState, billable: boolean, glAccount?: string | null, taxable: boolean, canAdjust: boolean, canSplit: boolean, canPsApprove: boolean, canBaApprove: boolean, canPmApprove: boolean, canEditTaxable: boolean, canEditBillable: boolean, canMoveProject: boolean, canPostToInvoice: boolean, canOverrideRate: boolean, lastEditNotes?: string | null, projectId: number, type: Types.ChargeType, rateSheetName?: string | null, employee?: { __typename?: 'Employee', firstName: string, middleInitial: string, lastName: string, userPrincipalName: string } | null, history?: Array<{ __typename?: 'ProjectChangedHistoryItem', changedBy: string, changedOn: any, event: string } | { __typename?: 'ProjectChargeBillableHistoryItem', changedBy: string, changedOn: any, event: string } | { __typename?: 'ProjectChargeEditedHistoryItem', label: string, notes?: string | null, rate: number, quantity?: number | null, billable: boolean, editNotes: string, eeCode: string, date?: string | null, changedBy: string, changedOn: any, event: string } | { __typename?: 'ProjectChargeEeCodeHistoryItem', changedBy: string, changedOn: any, event: string } | { __typename?: 'ProjectChargeHistoryItem', changedBy: string, changedOn: any, event: string } | { __typename?: 'ProjectChargeHistoryItemDetailed', label: string, notes?: string | null, rate: number, quantity?: number | null, billable: boolean, eeCode: string, changedBy: string, changedOn: any, event: string } | { __typename?: 'ProjectChargeQuantityHistoryItem', changedBy: string, changedOn: any, event: string } | { __typename?: 'ProjectChargeTaxableHistoryItem', changedBy: string, changedOn: any, event: string } | null> | null, project?: { __typename?: 'Project', name: string, number: number, budget?: number | null, afe?: string | null, canAddCharge: boolean, billingAdmin?: { __typename?: 'Employee', firstName: string, middleInitial: string, lastName: string, userPrincipalName: string, ultiProId: string } | null, projectManager?: { __typename?: 'Employee', firstName: string, middleInitial: string, lastName: string, userPrincipalName: string, ultiProId: string } | null, projectSupervisor?: { __typename?: 'Employee', firstName: string, middleInitial: string, lastName: string, userPrincipalName: string, ultiProId: string } | null, location?: { __typename?: 'StateCounty', state: string, county: string } | null, customer?: { __typename?: 'Customer', name: string, number?: string | null } | null, stats?: { __typename?: 'ProjectStats', totalUnbilled: number, totalBilled: number, totalPrPending: number, totalPendingApproval: number, totalPendingBilling: number, totalPmPending: number, totalNonBillable: number } | null, overheadEeCode?: { __typename?: 'EeCodeRecord', eeCode: string } | null } | null } | null> | null } | null };


export const ChargesDocument = gql`
    query Charges($projectCharges: [Int!]!) {
  projectCharges {
    charges(projectCharges: $projectCharges) {
      id
      label
      notes
      date
      rate
      unit
      quantity
      timesheetQuantity
      eeCode
      total
      state
      billable
      glAccount
      taxable
      employee {
        firstName
        middleInitial
        lastName
        userPrincipalName
      }
      history {
        changedBy
        changedOn
        event
        ... on ProjectChargeHistoryItemDetailed {
          label
          notes
          rate
          quantity
          billable
          eeCode
        }
        ... on ProjectChargeEditedHistoryItem {
          label
          notes
          rate
          quantity
          billable
          editNotes
          eeCode
          date
        }
      }
      canAdjust
      canSplit
      canPsApprove
      canBaApprove
      canPmApprove
      canEditTaxable
      canEditBillable
      canMoveProject
      canPostToInvoice
      canOverrideRate
      lastEditNotes
      projectId
      project {
        name
        number
        budget
        billingAdmin {
          firstName
          middleInitial
          lastName
          userPrincipalName
          ultiProId
        }
        projectManager {
          firstName
          middleInitial
          lastName
          userPrincipalName
          ultiProId
        }
        projectSupervisor {
          firstName
          middleInitial
          lastName
          userPrincipalName
          ultiProId
        }
        location {
          state
          county
        }
        customer {
          name
          number
        }
        stats {
          totalUnbilled
          totalBilled
          totalPrPending
          totalPendingApproval
          totalPendingBilling
          totalPmPending
          totalNonBillable
        }
        afe
        canAddCharge
        overheadEeCode {
          eeCode
        }
      }
      type
      rateSheetName
    }
  }
}
    `;

/**
 * __useChargesQuery__
 *
 * To run a query within a React component, call `useChargesQuery` and pass it any options that fit your needs.
 * When your component renders, `useChargesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChargesQuery({
 *   variables: {
 *      projectCharges: // value for 'projectCharges'
 *   },
 * });
 */
export function useChargesQuery(baseOptions: Apollo.QueryHookOptions<ChargesQuery, ChargesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChargesQuery, ChargesQueryVariables>(ChargesDocument, options);
      }
export function useChargesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChargesQuery, ChargesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChargesQuery, ChargesQueryVariables>(ChargesDocument, options);
        }
export type ChargesQueryHookResult = ReturnType<typeof useChargesQuery>;
export type ChargesLazyQueryHookResult = ReturnType<typeof useChargesLazyQuery>;
export type ChargesQueryResult = Apollo.QueryResult<ChargesQuery, ChargesQueryVariables>;